export const CUSTOM_FIELD_VALUE_TYPES = {
  CustomFieldValueApiService: Symbol.for('CustomFieldValueApiService'),
  CustomFieldValueDao: Symbol.for('CustomFieldValueDao'),
  CustomFieldValueRepository: Symbol.for('CustomFieldValueRepository'),
  CustomFieldValueUseCase: Symbol.for('CustomFieldValueUseCase'),
};
